import Component from '@glimmer/component';
import { eq } from 'ember-truth-helpers';

// Generalizes the `ew2-lineups-tooltip` rate-up / rate-down affordance into a
// reusable, token-themed stat-delta indicator (ESPN "semantic colour on deltas").
//
// The direction is ALWAYS derived from data — never hardcoded by the caller's
// eye. Pass a numeric `@delta` (positive = good/up, negative = bad/down, 0 =
// neutral) and it colours itself with --color-status-positive / -negative.
//
// Args:
//   @delta      - number used to derive direction (sign). Required unless
//                 @direction is passed explicitly.
//   @direction  - optional override: 'up' | 'down' | 'neutral'. Use when the
//                 "good" direction is not the numeric sign (e.g. deaths: lower
//                 is better) — the caller still derives it from data.
//   @value      - display text (defaults to the raw @delta). e.g. '2.4', '+3'.
//   @title      - optional tooltip label.
export default class StatDelta extends Component {
  get direction() {
    if (this.args.direction) return this.args.direction;
    const d = Number(this.args.delta);
    if (Number.isNaN(d) || d === 0) return 'neutral';
    return d > 0 ? 'up' : 'down';
  }

  get display() {
    const { value, delta } = this.args;
    return value !== undefined && value !== null ? value : delta;
  }

  <template>
    <span class='stat-delta stat-delta--{{this.direction}}' data-title={{@title}} ...attributes>
      {{#if (eq this.direction 'up')}}
        <svg class='stat-delta-icon' aria-hidden='true'>
          <use href='#svg-plus-big'></use>
        </svg>
      {{else if (eq this.direction 'down')}}
        <svg class='stat-delta-icon' aria-hidden='true'>
          <use href='#svg-minus-cc'></use>
        </svg>
      {{/if}}
      <span class='stat-delta-value'>{{this.display}}</span>
    </span>
  </template>
}
